
import { defineComponent, computed } from 'vue'
import HeartIcon from '@/assets/icons/heart.svg?inline'
import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'CardBlogPost',
  components: {
    HeartIcon,
  },
  setup() {
    const { currentTheme, currentMode, isLight } = useTheme()

    const cardClasses = computed(() => {
      const shadow = isLight.value ? 'shadow-xl' : ''

      return `${shadow} rounded-3xl`
    })

    const cardBg = computed(() => {
      return isLight.value
        ? currentTheme.value.bg.main
        : currentTheme.value.bg.card
    })

    const date = new Intl.DateTimeFormat('en-GB', {
      month: 'long',
      day: 'numeric',
    }).format(new Date())

    return {
      currentTheme,
      cardClasses,
      currentMode,
      cardBg,
      date,
    }
  },
})
